export default function getAllLiaisonTarifById(produit, ids) {
  if (!produit.liaisonsTarif) return null;
  const result = produit.liaisonsTarif.filter((ligne) => {
    return ids.includes(ligne.id);
  });
  if (result.length === 0) {
    return null;
  }
  return result;
}
